<template>
  <!-- <form id="domo-form" @submit.prevent="submitForm">
    <input type="hidden" name="embedToken" v-model="embedToken">
  </form> -->
  <iframe id="iframe" src="" title="test"></iframe>
</template>

<script>
export default {
  name: 'Domo',
  data() {
    return {
      embedToken: '',
    };
  },
  async beforeCreate() {
    await fetch(`${process.env.VUE_APP_BACKEND_URL}/strategize_frontend/domo/authenticate`, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }).then(async (res) => {
      const data = await res.json();
      this.embedToken = data.result;
      this.reqListener();
    });
  },
  methods: {
    reqListener() {
      const iframe = document.getElementById('iframe');
      const embedURL = `https://public.domo.com/embed/pages/${process.env.VUE_APP_DOMO_EMBED_ID}`;
      const src = this.getGeneratedPageURL(this.embedToken, embedURL);
      iframe.srcdoc = src;

      const supportsSrcdoc = ('srcdoc' in document.createElement('iframe'));
      if (!supportsSrcdoc) {
        iframe.dataset.src = src;
        // eslint-disable-next-line no-script-url
        const js = 'javascript: window.frameElement.getAttribute("data-src")';
        iframe.setAttribute('src', js);
        iframe.contentWindow.location = js;
      }
    },
    getGeneratedPageURL(embedToken, embedUrl) {
      const source = `${'<html>\n'
          + '   <body>\n'
          + '        <form id="form" action="'}${embedUrl}" method="post">\n`
          + `        <input type="hidden" name="embedToken" value="${embedToken}">\n`
          + `        </form>\n`
          + `        <script>\n`
          + `        document.getElementById("form").submit();\n`
          // eslint-disable-next-line no-useless-escape
          + `        <\/script>\n`
          + `    </body>\n`
          + `</html>\n`;

      return source;
    },
  },
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 100%;
  border: none; /* Optional: Removes the border around the iframe */
}
</style>
